import UAParser from 'ua-parser-js'

export const getUserOs = (userAgent: string | undefined) => {
  if (!userAgent) {
    return null
  }
  const parser = new UAParser(userAgent)

  const { name, version } = parser.getOS()

  return { name, version }
}
